import React, { useState } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import Breadcrumb  from "components/Breadcrumb";
import PieChart from "components/ui/graph/PieChart";
import {Links} from 'routes/PathLink'
import Input from 'components/ui/input.jsx'
import Select from "react-select";
import {useAuth} from 'contexts/provider/AuthProvider'
import { useNavigate } from "react-router-dom";

import {
  useAllCompanyQuery, 
  useSaveDemoPFMutation
} from 'data/company';


export default function AddDemoPortFolio() {
  const [portfolioTitle, setPortfolioTitle] = useState("My Stock Portfolio");
  const [visibility, setVisibility] = useState("private");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [stocks, setStocks] = useState([
    { company: null,        // selected option object
      inputValue: "",       // search text
      qty: "", price: "" },
  ]);
  let navigate = useNavigate();

  const {logout, isUser} = useAuth();
  
   const { mutate:add_portfolio, isLoading } = useSaveDemoPFMutation();

  const {
      allcompanies,
      isLoading: loading,
      error,
    } = useAllCompanyQuery();

  const handleChange = (index, field, value) => {
    const updated = [...stocks];
    updated[index][field] = value;
    setStocks(updated);
  };

  
  const addStock = () => {
    setStocks([
    ...stocks,
    { company: null, inputValue: "", qty: "", price: "" },
    ]);
  };

  const removeStock = (index) => {
    const updated = stocks.filter((_, i) => i !== index);
    setStocks(updated);
  };

  const totalValue = stocks.reduce((sum, s) => {
    const qty = parseFloat(s.qty) || 0;
    const price = parseFloat(s.price) || 0;
    return sum + qty * price;
  }, 0);

  const breadcrumb = [
    {
      name:'Home',
      link:`${process.env.REACT_APP_URL}`,
    },
    {
      name:`Demo Portfolio`,
      link:`${process.env.REACT_APP_URL}${Links.SCREENS}`
    },
    {
      name:`${portfolioTitle}`,
      link:null
    },
  ];

  const handleSavePortfolio = async () => {
  if (!portfolioTitle.trim()) {
    alert("Portfolio name required");
    return;
  }

  if (stocks.length === 0) {
    alert("Add at least one stock");
    return;
  }

  const payload = {
    title: portfolioTitle,
    visibility,
    total_value: totalValue,
    stocks: stocks,
  };
  
   if(isUser){
        add_portfolio(payload);
      }else{
        navigate(`${Links.USER_LOGIN}`);
      }
  // POST to Laravel API
};


// 🔍 FILTER only matched data

/*const filteredOptions = allcompanies?.filter((c) =>
  c.name.toLowerCase().includes(inputValue.toLowerCase()) ||
  c.symbol.toLowerCase().includes(inputValue.toLowerCase())
);
*//*
const search = inputValue.toLowerCase();
const filteredOptions = allcompanies?.filter(c => {
  const name = c.name?.toLowerCase() || "";
  const symbol = c.symbol?.toLowerCase() || "";

  return name.includes(search) || symbol.includes(search);
});
*/

const getFilteredCompanies = (inputValue) => {
  const search = inputValue.toLowerCase();
  return allcompanies?.filter(c => {
    const name = c.name?.toLowerCase() || "";
    const symbol = c.symbol?.toLowerCase() || "";
    return name.includes(search) || symbol.includes(search);
  }) || [];
};



  return (
    <>
    <Header />
     <div className="space-y-5 px-5">
     <Breadcrumb breadcrumb={breadcrumb} />
    <section className="bg-white shadow-sm z-50 rounded-xl p-5">

     <div className="space-y-5 py-5">
      <h2 className="text-2xl">{portfolioTitle}</h2>
       <div className="w-full  space-y-4">
        <div className="w-full flex">
          <div className="w-6/12 space-x-2  ">
              {/*<label >
                Portfolio Name:
              </label>
              <input
              className="px-4 h-12 flex items-center w-full rounded appearance-none transition duration-300 ease-in-out text-heading text-sm focus:outline-none focus:ring-0 dark:bg-gray-600 dark:border-gray-700 dark:text-zinc-400"
                type="text"
                value={portfolioTitle}
                onChange={(e) => setPortfolioTitle(e.target.value)}
                placeholder="Enter portfolio title"
              />*/}

              <Input                
                label={`Portfolio Name`}
                value={portfolioTitle}
                variant="outline"
                className="mb-5 flex items-center w-8/12 text-nowrap space-x-2"
                placeholder="Enter portfolio title"
                onChange={(e) => setPortfolioTitle(e.target.value)}
              />
          </div>
        <div className="w-6/12 space-x-2 flex  items-center">
            <label className="mb-3 block text-sm font-semibold leading-none text-body-dark dark:text-zinc-400" >
              Visibility
            </label>
            <select
              value={visibility}
              onChange={(e) => setVisibility(e.target.value)}
             className="px-4 h-12 flex items-center  rounded appearance-none transition duration-300 ease-in-out text-heading text-sm focus:outline-none focus:ring-0 dark:bg-gray-600 dark:border-gray-700 dark:text-zinc-400"
            >
              <option value="private">🔒 Private</option>
              <option value="public">🌍 Public</option>
            </select>
            <span className="text-sm italic">
            {visibility === "private"
              ? "Only you can see this portfolio"
              : "Anyone with link can view this portfolio"}
              </span>
          </div>
        </div>

        <div className="space-x-2">
         {/*  <label >
          Portfolio Name:
          </label>
          <input
            type="text"
            value={portfolioTitle}
            onChange={(e) => setPortfolioTitle(e.target.value)}
            placeholder="Enter portfolio title"
            style={{ padding: "6px", width: "300px" }}
          />*/}

          <Input                
                label={`Portfolio Name`}
                value={portfolioTitle}
                variant="outline"
                className="mb-5 flex items-center w-4/12 text-nowrap space-x-2"
                placeholder="Enter portfolio title"
                onChange={(e) => setPortfolioTitle(e.target.value)}
              />
        </div>
      </div>
       
      </div>

      <table >
        <thead>
          <tr>
            <th>Stock Name</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {stocks.map((stock, index) => (
            <tr key={index}>
              <td>
                {/*<input
                  type="text"
                  placeholder="TCS"
                  value={stock.name}
                  onChange={(e) => handleChange(index, "name", e.target.value)}
                />*/}
                {/*<Select
                options={companies}
                value={selectedCompany}
                onChange={setSelectedCompany}
                placeholder="Select company..."
                isSearchable
              />*/}
              <div className="w-full max-w-md">
              <Select
              getOptionLabel={(option) => option.name}     // 👈 display text
              getOptionValue={(option) => option.symbol}   // 👈 unique value
              options={
                stock.inputValue.length > 0
                  ? getFilteredCompanies(stock.inputValue)
                  : stock.company
                  ? [stock.company]
                  : []
              }
            value={stock.company}
               onChange={(val) => {
                const updated = [...stocks];
                updated[index].company = val;
                updated[index].inputValue = "";
                updated[index].name = val?.symbol || "";
                setStocks(updated);
              }}
              inputValue={stock.inputValue}
              onInputChange={(val, meta) => {
                if (meta.action === "input-change") {
                  const updated = [...stocks];
                  updated[index].inputValue = val;
                  setStocks(updated);
                }
              }}
              placeholder="Search company..."
              isClearable
              isSearchable
              menuIsOpen={stock.inputValue.length > 0}      // ✅ FORCE open
              noOptionsMessage={() =>
                inputValue ? "No company found" : "Type to search"
              }
                styles={{
                    control: (base) => ({
                      ...base,
                      minWidth: "280px",
                      width: "100%",
                    }),
                    input: (base) => ({
                      ...base,
                      minWidth: "120px",
                    }),
                  }}
            />
              {/*<Select
              cacheOptions
              defaultOptions={false}   // ⬅️ IMPORTANT
              options={inputValue ? filteredOptions : []}
              value={selectedCompany}
              onInputChange={(value) => setInputValue(value)}
              onChange={setSelectedCompany}
              placeholder="Search company..."
              isClearable
            />*/}
            </div>
              </td>
              <td>
                <input
                  className="px-4 h-12 flex items-center w-full rounded appearance-none transition duration-300 ease-in-out text-heading text-sm focus:outline-none focus:ring-0 dark:bg-gray-600 dark:border-gray-700 dark:text-zinc-400"
                  type="number"
                  placeholder="10"
                  value={stock.qty}
                  onChange={(e) => handleChange(index, "qty", e.target.value)}
                />
              </td>
              <td>
                <input
                className="px-4 h-12 flex items-center w-full rounded appearance-none transition duration-300 ease-in-out text-heading text-sm focus:outline-none focus:ring-0 dark:bg-gray-600 dark:border-gray-700 dark:text-zinc-400"
                  type="number"
                  placeholder="3500"
                  value={stock.price}
                  onChange={(e) => handleChange(index, "price", e.target.value)}
                />
              </td>
              <td>
                {(parseFloat(stock.qty) || 0) * (parseFloat(stock.price) || 0)}
              </td>
              <td>
                <button onClick={() => removeStock(index)}>❌</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button onClick={addStock}>
        ➕ Add More Stock
      </button>
      <h2>Total Portfolio Value: ₹{totalValue.toFixed(2)}</h2>
       <div>
        <button onClick={handleSavePortfolio} class="my-4 px-4 py-2 bg-accent-600 text-white rounded">
          💾 Save Portfolio
        </button>
       </div>
      <PieChart stocks={stocks} />
    </section>
    </div>
   <Footer />
    </>
  );
}


const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 40,
    height: 40,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
};


/*
const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    maxWidth: "900px",
    margin: "0 auto",
    padding: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "20px",
  },
  addBtn: {
    padding: "10px 15px",
    cursor: "pointer",
    marginBottom: "20px",
  },
};
*/